import React from 'react';
import PropTypes from 'prop-types';
import MLButton from '../../../MLButton';

import s from './EmptyCourseList.module.css';

const EmptyCourseList = ({ onClickCreateCourse, onClickRefreshList }) => {
  return (
    <div className={s.noCourses} data-test-id="no-courses">
      <b>You don&apos;t have any iClicker courses.</b>
      <p>
        You can create a
        <MLButton
          onClick={onClickCreateCourse}
          testId="create-reef-course-button"
        >
          <span className={s.linkColor}>new iClicker course</span>
        </MLButton>{' '}
        to link with Achieve.
        <br />
        If you have iClicker courses that don&apos;t seem to be loading, try
        <MLButton
          onClick={onClickRefreshList}
          testId="refresh-reef-course-button"
        >
          <span className={s.linkColor}>refreshing the list</span>
        </MLButton>
        .
      </p>
    </div>
  );
};

EmptyCourseList.propTypes = {
  onClickCreateCourse: PropTypes.func,
  onClickRefreshList: PropTypes.func,
};

export default EmptyCourseList;
